import { render, staticRenderFns } from "./list-heading.vue?vue&type=template&id=5c55361e&"
import script from "./list-heading.vue?vue&type=script&lang=js&"
export * from "./list-heading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports